import { Version } from '@fuse/version/version';

export const FUSE_VERSION = new Version('13.4.0').full;
